/* eslint-disable no-class-assign */
/* eslint-disable react/jsx-key */
import {
  Card,
  CardHeader,
  Checkbox,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Delete from "@material-ui/icons/Delete";
import Search from "@material-ui/icons/Search";
import axios from "axios";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import TableData from "../../components/TableData";
import * as cookie from "../../helper/cookie";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/telesale/form";
import { mapActionsToProps as questionAction } from "../../redux/telesale/question";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: grid,
  width: "100%",
  borderRadius: "5px",
});

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";
const API_PATH = process.env.REACT_APP_API_PATH || "";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  cardQuestion: {
    width: "100%",
    marginBottom: theme.spacing.unit * 3,
    border: "1px solid #fff",
  },
  deleteCheckbox: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    color: "#fff",
  },
});

class FormTelesale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      idOption: 0,
      item: null,
      modalAction: false,
      modalDelete: false,
      token: "",
      itemCreate: {
        questions: [
          {
            type: "",
            title: "",
            note: "",
            id:
              1 +
              Math.random().toString(36).substring(2, 4) +
              Math.random().toString(36).substring(2, 4),
            options: [
              {
                id:
                  1 +
                  Math.random().toString(36).substring(2, 4) +
                  Math.random().toString(36).substring(2, 4),
                text: "",
              },
            ],
          },
        ],
      },
    };
  }

  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.setState({ token: cookie.getCookie("access_token") });
  }

  listCollumns = [
    {
      id: "name",
      numeric: true,
      disablePadding: false,
      label: "Tên mẫu khảo sát",
    },
    {
      id: "campaign",
      numeric: true,
      disablePadding: false,
      label: "Chiến dịch",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            case "campaignId":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListForm({ where: where });
    this.props.getListForm(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        relation: "campaign",
        scope: { fields: { id: true, name: true } },
      }
    );
    this.props.getListQuestion(filters.order, null, null, null);
    this.props.getAllCampaigns();
    this.props.getReasonSelectList();
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      questions: [
        {
          type: "",
          title: "",
          note: "",
          id:
            1 +
            Math.random().toString(36).substring(2, 4) +
            Math.random().toString(36).substring(2, 4),
          options: [
            {
              id:
                1 +
                Math.random().toString(36).substring(2, 4) +
                Math.random().toString(36).substring(2, 4),
              text: "",
            },
          ],
        },
      ],
    });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = name === "name" ? { like: value } : value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      const { id } = this.state.item;
      if (id) {
        this.setState({
          item: {
            ...this.state.item,
            [name]: e.target.value,
          },
        });
      } else {
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            [name]: e.target.value,
          },
        });
      }
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({
      modalAction: true,
      item: {},
      itemCreate: {
        questions: [
          {
            type: "",
            title: "",
            note: "",
            id:
              1 +
              Math.random().toString(36).substring(2, 4) +
              Math.random().toString(36).substring(2, 4),
            options: [
              {
                id:
                  1 +
                  Math.random().toString(36).substring(2, 4) +
                  Math.random().toString(36).substring(2, 4),
                text: "",
              },
            ],
          },
        ],
      },
    });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (id) {
      const { id, name, campaignId, questions, note, content } =
        this.state.item;
      return (
        this.props.editForm(
          id,
          name,
          campaignId,
          { questions: questions },
          note,
          content
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const { name, campaignId, questions, note, content } =
        this.state.itemCreate;

      return (
        this.props.addNewForm(
          name,
          campaignId,
          { questions: questions },
          note,
          content
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteForm(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleChangeQuestion = (name, value, key, e) => {
    if (e) {
      setTimeout(() => document.activeElement.blur(), 0);
    }
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const newQuestion = questions.map((question, i) => {
        if (i !== key) return question;
        return { ...question, [name]: value };
      });
      this.setState({
        item: {
          ...this.state.item,
          questions: newQuestion,
        },
      });
    } else {
      const { questions } = this.state.itemCreate;
      const newQuestion = questions.map((question, i) => {
        if (i !== key) return question;
        return { ...question, [name]: value };
      });
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          questions: newQuestion,
        },
      });
    }
  };

  handleAddNewQuestion = (e) => {
    e.preventDefault();

    const suffix =
      Math.random().toString(36).substring(2, 4) +
      Math.random().toString(36).substring(2, 4);
    const { id } = this.state.item;
    if (id) {
      const { questions } = this.state.item;
      for (let i = 0; i < questions.length; i++) {
        this.setState({
          item: {
            ...this.state.item,
            questions: questions.concat([
              {
                type: "",
                title: "",
                note: "",
                id: questions.length + 1 + suffix,
                options: [
                  { id: questions[i].options.length + 1 + suffix, text: "" },
                ],
              },
            ]),
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      for (let i = 0; i < questions.length; i++) {
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: questions.concat([
              {
                type: "",
                title: "",
                note: "",
                id: questions.length + 1 + suffix,
                options: [
                  { id: questions[i].options.length + 1 + suffix, text: "" },
                ],
              },
            ]),
          },
        });
      }
    }
  };

  handleRemoveQuestion = (key) => () => {
    const { id } = this.state.item;
    if (id) {
      this.setState({
        item: {
          ...this.state.item,
          questions: this.state.item.questions.filter((q, id) => key !== id),
        },
      });
    } else {
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          questions: this.state.itemCreate.questions.filter(
            (q, id) => key !== id
          ),
        },
      });
    }
  };

  handleAddNewOption = (e, type, idOption) => {
    e.preventDefault();

    const suffix =
      Math.random().toString(36).substring(2, 4) +
      Math.random().toString(36).substring(2, 4);
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const question = questions.find(
        (q) => q.type === type && q.id === idOption
      );
      if (question) {
        for (let i = 0; i < question.options.length; i++) {
          const newOption = question.options.concat([
            { id: question.options.length + 1 + suffix, text: "" },
          ]);
          const newQuestion = questions.map((q) => {
            if (q.id !== question.id) return q;
            return {
              ...q,
              options: newOption,
            };
          });
          this.setState({
            item: {
              ...this.state.item,
              questions: newQuestion,
            },
          });
        }
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find(
        (q) => q.type === type && q.id === idOption
      );

      if (question) {
        for (let i = 0; i < question.options.length; i++) {
          const newOption = question.options.concat([
            { id: question.options.length + 1 + suffix, text: "" },
          ]);
          const newQuestion = questions.map((q) => {
            if (q.id !== question.id) return q;
            return {
              ...q,
              options: newOption,
            };
          });
          this.setState({
            itemCreate: {
              ...this.state.itemCreate,
              questions: newQuestion,
            },
          });
        }
      }
    }
  };

  handleRemoveOption = (idOption, type, idQuestion) => {
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const question = questions.find(
        (q) => q.type === type && idQuestion === q.id
      );
      if (question) {
        const newOption = question.options.filter((o, i) => idOption !== o.id);
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          item: {
            ...this.state.item,
            questions: newQuestion,
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find(
        (q) => q.type === type && idQuestion === q.id
      );
      if (question) {
        const newOption = question.options.filter((o) => idOption !== o.id);

        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: newQuestion,
          },
        });
      }
    }
  };

  handleChangeReasonOption = (name, value, idQuestion, selectReason) => {
    const { id } = this.state.item;
    if (id) {
      const { questions } = this.state.item;
      const question = questions.find(
        (q) => q.type === name && q.id === idQuestion
      );
      const itemSelected = selectReason.find((n) => n.id === value);
      if (question) {
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: {
              type: "select-list",
              text: itemSelected.text,
              id: value,
            },
          };
        });
        this.setState({
          item: {
            ...this.state.item,
            questions: newQuestion,
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find(
        (q) => q.type === name && q.id === idQuestion
      );
      const itemSelected = selectReason.find((n) => n.id === value);
      if (question) {
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: {
              type: "select-list",
              text: itemSelected.text,
              id: value,
            },
          };
        });
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: newQuestion,
          },
        });
      }
    }
  };

  handleChangeTextOption = (name, value, idOption, idQuestion) => {
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const question = questions.find(
        (q) => q.type === name && q.id === idQuestion
      );
      if (question) {
        const newOption = question.options.map((option) => {
          if (idOption !== option.id) return option;
          return {
            ...option,
            id: option.id,
            text: value,
          };
        });
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          item: {
            ...this.state.item,
            questions: newQuestion,
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find(
        (q) => q.type === name && q.id === idQuestion
      );

      if (question) {
        const newOption = question.options.map((option) => {
          if (idOption !== option.id) return option;
          return {
            ...option,
            id: option.id,
            text: value,
          };
        });
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: newQuestion,
          },
        });
      }
    }
  };

  handleChangeScaleOption = (name, value, idOption, idQuestion) => {
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const question = questions.find((q) => q.id === idQuestion);
      if (question) {
        const newOption = question.options.map((option) => {
          if (idOption === option.id) {
            if (name === "scale-start") {
              return {
                ...option,
                text: [
                  {
                    value,
                    text:
                      option.text[0] && option.text[0].text
                        ? option.text[0].text
                        : "",
                  },
                  option.text[1],
                ],
              };
            } else if (name === "scale-end") {
              return {
                ...option,
                text: [
                  option.text[0],
                  {
                    value,
                    text:
                      option.text[1] && option.text[1].text
                        ? option.text[1].text
                        : "",
                  },
                ],
              };
            } else if (name === "scale-text-start") {
              return {
                ...option,
                text: [
                  {
                    value:
                      option.text[0] && option.text[0].value
                        ? option.text[0].value
                        : 0,
                    text: value,
                  },
                  option.text[1],
                ],
              };
            } else if (name === "scale-text-end") {
              return {
                ...option,
                text: [
                  option.text[0],
                  {
                    value:
                      option.text[1] && option.text[1].value
                        ? option.text[1].value
                        : 2,
                    text: value,
                  },
                ],
              };
            }
          }
          return option;
        });
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          item: {
            ...this.state.item,
            questions: newQuestion,
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find((q) => q.id === idQuestion);

      if (question) {
        const newOption = question.options.map((option) => {
          if (idOption === option.id) {
            if (name === "scale-start") {
              return {
                ...option,
                text: [
                  {
                    value,
                    text:
                      option.text[0] && option.text[0].text
                        ? option.text[0].text
                        : "",
                  },
                  option.text[1],
                ],
              };
            } else if (name === "scale-end") {
              return {
                ...option,
                text: [
                  option.text[0],
                  {
                    value,
                    text:
                      option.text[1] && option.text[1].text
                        ? option.text[1].text
                        : "",
                  },
                ],
              };
            } else if (name === "scale-text-start") {
              return {
                ...option,
                text: [
                  {
                    value:
                      option.text[0] && option.text[0].value
                        ? option.text[0].value
                        : 0,
                    text: value,
                  },
                  option.text[1],
                ],
              };
            } else if (name === "scale-text-end") {
              return {
                ...option,
                text: [
                  option.text[0],
                  {
                    value:
                      option.text[1] && option.text[1].value
                        ? option.text[1].value
                        : 2,
                    text: value,
                  },
                ],
              };
            }
          }
          return option;
        });
        const newQuestion = questions.map((q) => {
          if (q.id !== question.id) return q;
          return {
            ...q,
            options: newOption,
          };
        });
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: newQuestion,
          },
        });
      }
    }
  };

  handleChangeTextQuestion = (name, value, idQuestion) => {
    const { id } = this.state.item;

    if (id) {
      const { questions } = this.state.item;
      const question = questions.find((q) => q.id === idQuestion);
      if (question) {
        const newQuestion = questions.map((q) => {
          if (q.id === idQuestion) {
            return {
              ...q,
              note: value,
            };
          }
          return q;
        });
        this.setState({
          item: {
            ...this.state.item,
            questions: newQuestion,
          },
        });
      }
    } else {
      const { questions } = this.state.itemCreate;
      const question = questions.find((q) => q.id === idQuestion);

      if (question) {
        const newQuestion = questions.map((q) => {
          if (q.id === idQuestion) {
            return {
              ...q,
              note: value,
            };
          }
          return q;
        });
        this.setState({
          itemCreate: {
            ...this.state.itemCreate,
            questions: newQuestion,
          },
        });
      }
    }
  };

  upload = (e, type, idOption, idQuestion) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    axios
      .post(
        `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/upload`,
        data,
        {
          headers: {
            Authorization: this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        const { id } = this.state;
        this.setState({ fileName: res.data }, () => {
          if (!id) {
            const { questions } = this.state;
            const question = questions.find(
              (q) => q.type === type && q.id === idQuestion
            );

            if (question) {
              // const newOption = question.options.map(option => {
              //     if (idOption !== option.id) return option;
              //     return {
              //         ...option,
              //         container: this.state.fileName.result.files.file[0].container,
              //         name: this.state.fileName.result.files.file[0].name
              //     }
              // })
              const newQuestion = questions.map((q) => {
                if (q.id !== question.id) return q;
                return {
                  ...q,
                  options: [
                    {
                      container:
                        this.state.fileName.result.files.file[0].container,
                      name: this.state.fileName.result.files.file[0].name,
                    },
                  ],
                };
              });
              this.setState({
                questions: newQuestion,
              });
            }
          } else {
            const { questions } = this.state.item;
            const question = questions.find(
              (q) => q.type === type && q.id === idQuestion
            );
            if (question) {
              // const newOption = question.options.map(option => {
              //     if (idOption !== option.id) return option;
              //     return {
              //         ...option,
              //         container: this.state.fileName.result.files.file[0].container,
              //         name: this.state.fileName.result.files.file[0].name
              //     }
              // })
              const newQuestion = questions.map((q) => {
                if (q.id !== question.id) return q;
                return {
                  ...q,
                  options: [
                    {
                      container:
                        this.state.fileName.result.files.file[0].container,
                      name: this.state.fileName.result.files.file[0].name,
                    },
                  ],
                };
              });
              this.setState({
                item: {
                  ...this.state.item,
                  questions: newQuestion,
                },
              });
            }
          }
        });
      });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { id, questions } = this.state.item;

    if (id) {
      const items = reorder(
        questions,
        result.source.index,
        result.destination.index
      );

      this.setState({
        item: {
          ...this.state.item,
          questions: items,
        },
      });
    } else {
      const items = reorder(
        this.state.questions,
        result.source.index,
        result.destination.index
      );

      this.setState({
        questions: items,
      });
    }
  };

  render() {
    const {
      classes,
      listFormTelesale,
      coutFormTelesale,
      listQuestion,
      reasonSelectList,
    } = this.props;
    const {
      name,
      note,
      options,
      campaignId,
      content,
      filters,
      item,
      modalDelete,
      itemCreate,
    } = this.state;
    const { questions } = this.state.itemCreate;
    const listFormTelesaleResult =
      typeof listFormTelesale === "object"
        ? Object.keys(listFormTelesale).map((key) => listFormTelesale[key])
        : listFormTelesale;
    const listQuestionResult =
      typeof listQuestion === "object"
        ? Object.keys(listQuestion).map((key) => listQuestion[key])
        : listQuestion;

    let selectReason = [];

    if (reasonSelectList.length > 0) {
      reasonSelectList.forEach((item) => {
        selectReason.push({ id: item.id, text: item.name });
      });
    }

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên kịch bản"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.name ? filters.where.name.like : ""
                        }
                        name="name"
                      />
                    </Grid>
                    <Grid item md={4}>
                      <SelectValidator
                        id="outlined-full-width"
                        margin="normal"
                        select
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Chiến dịch"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.campaignId}
                        name="campaignId">
                        <MenuItem key={"all"} value={""}>
                          Tất cả
                        </MenuItem>
                        {_.values(this.props.allCampaign) &&
                        _.values(this.props.allCampaign).length
                          ? _.values(this.props.allCampaign).map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </SelectValidator>
                    </Grid>
                    <Grid item md={4}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách phiếu câu hỏi khảo sát"
          items={listFormTelesaleResult}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                onClick={this.handleCreateModel}
                size="small">
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa mẫu khảo sát?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalAction}
          fullScreen={false}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thông tin mẫu khảo sát"
                : "Thêm mẫu khảo sát"
              : null
          }
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên phiếu câu hỏi khảo sát"
                    variant="outlined"
                    inputRef={(e) => (this.name = e)}
                    className={classes.input}
                    autoFocus={true}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("name")
                          : this.handleChangeText("name")
                        : null
                    }
                    value={
                      item ? (item.id ? item.name : itemCreate.name) : null
                    }
                    name="name"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <SelectValidator
                    id="select-campaign"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Chiến dịch"
                    variant="outlined"
                    className={classes.input}
                    inputRef={(event) => (this.campaignId = event)}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("campaignId")
                          : this.handleChangeText("campaignId")
                        : null
                    }
                    value={
                      item
                        ? item.id
                          ? item.campaignId
                          : itemCreate.campaignId
                        : ""
                    }
                    name="campaignId"
                    validators={["required"]}
                    errorMessages={"Không được để trống"}>
                    <MenuItem key={"all"} value={""}>
                      Tất cả
                    </MenuItem>
                    {_.values(this.props.allCampaign) &&
                    _.values(this.props.allCampaign).length
                      ? _.values(this.props.allCampaign).map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Nội dung"
                    variant="outlined"
                    className={classes.input}
                    inputRef={(e) => (this.content = e)}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("content")
                          : this.handleChangeText("content")
                        : null
                    }
                    value={
                      item
                        ? item.id
                          ? item.content
                          : itemCreate.content
                        : null
                    }
                    name="content"
                    ute
                    line
                    rows={5}
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Ghi chú"
                    variant="outlined"
                    inputRef={(e) => (this.note = e)}
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("note")
                          : this.handleChangeText("note")
                        : null
                    }
                    value={
                      item ? (item.id ? item.note : itemCreate.note) : null
                    }
                    name="note"
                    multiline
                    rows={3}
                  />
                  {item ? (
                    item.id ? (
                      <React.Fragment>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}>
                                {item.questions.map((question, key) => (
                                  <Draggable
                                    key={key}
                                    draggableId={question.id}
                                    index={key}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        // style={getItemStyle(
                                        //   snapshot.isDragging,
                                        //   provided.draggableProps.style
                                        // )}
                                      >
                                        <Card className={classes.cardQuestion}>
                                          <CardHeader
                                            style={{ paddingBottom: 0 }}
                                            title={`Câu hỏi ${key + 1}`}
                                            action={
                                              key ===
                                              item.questions.length - 1 ? (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}>
                                                  <Tooltip
                                                    title="Thêm mới"
                                                    disableFocusListener>
                                                    <Fab
                                                      color="primary"
                                                      aria-label="add"
                                                      size="small"
                                                      style={{
                                                        margin: 5,
                                                        marginBottom: 0,
                                                      }}
                                                      onClick={
                                                        this
                                                          .handleAddNewQuestion
                                                      }>
                                                      <Add
                                                        className={classes.add}
                                                      />
                                                    </Fab>
                                                  </Tooltip>
                                                </div>
                                              ) : null
                                            }
                                          />
                                          <CardContent>
                                            <SelectValidator
                                              id="outlined-full-width"
                                              margin="normal"
                                              select
                                              SelectProps={{
                                                MenuProps: {
                                                  className: classes.menu,
                                                  shrink: true,
                                                },
                                              }}
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              label="Loại câu hỏi"
                                              variant="outlined"
                                              className={classes.input}
                                              onChange={(e) => {
                                                this.handleChangeQuestion(
                                                  e.target.name,
                                                  e.target.value,
                                                  key,
                                                  e
                                                );
                                              }}
                                              value={
                                                item
                                                  ? item.id
                                                    ? item.questions[key].type
                                                    : ""
                                                  : ""
                                              }
                                              name="type"
                                              validators={["required"]}
                                              errorMessages={
                                                "Không được để trống"
                                              }>
                                              {listQuestionResult
                                                ? listQuestionResult.map(
                                                    (item) => {
                                                      return (
                                                        <MenuItem
                                                          key={item.id}
                                                          value={item.id}>
                                                          {item.name}
                                                        </MenuItem>
                                                      );
                                                    }
                                                  )
                                                : null}
                                            </SelectValidator>
                                            {question.type ? (
                                              <React.Fragment>
                                                <TextValidator
                                                  id="outlined-full-width"
                                                  margin="normal"
                                                  label={`Câu hỏi`}
                                                  className={classes.input}
                                                  onChange={(e) => {
                                                    this.handleChangeQuestion(
                                                      e.target.name,
                                                      e.target.value,
                                                      key
                                                    );
                                                  }}
                                                  value={
                                                    item
                                                      ? item.id
                                                        ? item.questions[key]
                                                            .title
                                                        : ""
                                                      : ""
                                                  }
                                                  name="title"
                                                  validators={["required"]}
                                                  errorMessages="Không được để trống"
                                                />
                                                {question.type ===
                                                "datetime" ? (
                                                  <Grid
                                                    container
                                                    className={classes.grid}>
                                                    <Grid item md={6}>
                                                      <TextField
                                                        margin="normal"
                                                        className={
                                                          classes.input
                                                        }
                                                        label="dd/MM/yyyy"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <Icon>
                                                                event_note
                                                              </Icon>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        disabled
                                                      />
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      md={6}
                                                      style={{
                                                        paddingLeft: 5,
                                                      }}>
                                                      <TextField
                                                        margin="normal"
                                                        className={
                                                          classes.input
                                                        }
                                                        label="HH:mm"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <Icon>
                                                                access_time
                                                              </Icon>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        disabled
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                ) : question.type === "time" ? (
                                                  <TextField
                                                    margin="normal"
                                                    className={classes.input}
                                                    label="HH:mm"
                                                    InputProps={{
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <Icon>
                                                            access_time
                                                          </Icon>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    disabled
                                                  />
                                                ) : question.type === "date" ? (
                                                  <TextField
                                                    margin="normal"
                                                    className={classes.input}
                                                    label="dd/MM/yyyy"
                                                    disabled
                                                    InputProps={{
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <Icon>
                                                            event_note
                                                          </Icon>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                  />
                                                ) : question.type === "text" ? (
                                                  <TextField
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label="Câu trả lời ngắn"
                                                    className={classes.input}
                                                    disabled
                                                  />
                                                ) : question.type ===
                                                  "paragraph-text" ? (
                                                  <TextField
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label="Câu trả lời dài"
                                                    disabled
                                                    className={classes.input}
                                                  />
                                                ) : question.type ===
                                                  "check-box" ? (
                                                  <FormGroup row>
                                                    <RadioGroup
                                                      aria-label="Gender"
                                                      name="checkBox"
                                                      className={classes.input}>
                                                      <FormControlLabel
                                                        value="Đồng ý"
                                                        control={
                                                          <Radio color="primary" />
                                                        }
                                                        label="Đồng ý"
                                                      />
                                                      <FormControlLabel
                                                        value="Không đồng ý"
                                                        control={
                                                          <Radio color="primary" />
                                                        }
                                                        label="Không đồng ý"
                                                      />
                                                    </RadioGroup>
                                                  </FormGroup>
                                                ) : question.type ===
                                                  "select" ? (
                                                  <React.Fragment>
                                                    {question.options.map(
                                                      (item, i) => {
                                                        return (
                                                          <Grid
                                                            key={i}
                                                            container
                                                            className={
                                                              classes.grid
                                                            }>
                                                            <Grid item md={1}>
                                                              <div
                                                                style={{
                                                                  marginTop:
                                                                    "20px",
                                                                  marginRight:
                                                                    "10px",
                                                                }}>
                                                                <span>
                                                                  {i + 1}.
                                                                </span>
                                                              </div>
                                                            </Grid>
                                                            <Grid item md={9}>
                                                              <TextField
                                                                id="outlined-full-width"
                                                                margin="normal"
                                                                placeholder="Thêm tùy chọn"
                                                                className={
                                                                  classes.input
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleChangeTextOption(
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value,
                                                                    item.id,
                                                                    question.id
                                                                  )
                                                                }
                                                                value={
                                                                  question
                                                                    .options[i]
                                                                    .text
                                                                }
                                                                name="select"
                                                              />
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              md={2}
                                                              className={
                                                                classes.deleteCheckbox
                                                              }>
                                                              {i === 0 ? (
                                                                <Tooltip
                                                                  title="Thêm mới"
                                                                  disableFocusListener>
                                                                  <Fab
                                                                    color="primary"
                                                                    aria-label="add"
                                                                    className={
                                                                      classes.fab
                                                                    }
                                                                    size="small"
                                                                    onClick={(
                                                                      e
                                                                    ) =>
                                                                      this.handleAddNewOption(
                                                                        e,
                                                                        question.type,
                                                                        question.id
                                                                      )
                                                                    }>
                                                                    <Add
                                                                      className={
                                                                        classes.add
                                                                      }
                                                                    />
                                                                  </Fab>
                                                                </Tooltip>
                                                              ) : (
                                                                <Delete
                                                                  onClick={() =>
                                                                    this.handleRemoveOption(
                                                                      item.id,
                                                                      question.type,
                                                                      question.id
                                                                    )
                                                                  }
                                                                  color="disabled"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              )}
                                                            </Grid>
                                                          </Grid>
                                                        );
                                                      }
                                                    )}
                                                  </React.Fragment>
                                                ) : question.type ===
                                                  "multi-check-box" ? (
                                                  <React.Fragment>
                                                    {question.options.map(
                                                      (multi, i) => {
                                                        return (
                                                          <Grid
                                                            key={i}
                                                            container
                                                            className={
                                                              classes.grid
                                                            }>
                                                            <Grid item md={10}>
                                                              <FormControlLabel
                                                                value={0}
                                                                control={
                                                                  <Checkbox
                                                                    disabled
                                                                  />
                                                                }
                                                                label={
                                                                  <TextField
                                                                    id="outlined-full-width"
                                                                    margin="normal"
                                                                    placeholder="Nôi dung lựa chọn"
                                                                    className={
                                                                      classes.input
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleChangeTextOption(
                                                                        e.target
                                                                          .name,
                                                                        e.target
                                                                          .value,
                                                                        multi.id,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    value={
                                                                      question
                                                                        .options[
                                                                        i
                                                                      ].text
                                                                    }
                                                                    name="multi-check-box"
                                                                  />
                                                                }
                                                              />
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              md={2}
                                                              className={
                                                                classes.deleteCheckbox
                                                              }>
                                                              {i === 0 ? (
                                                                <Tooltip
                                                                  title="Thêm mới"
                                                                  disableFocusListener>
                                                                  <Fab
                                                                    color="primary"
                                                                    aria-label="add"
                                                                    className={
                                                                      classes.fab
                                                                    }
                                                                    size="small"
                                                                    onClick={(
                                                                      e
                                                                    ) =>
                                                                      this.handleAddNewOption(
                                                                        e,
                                                                        question.type,
                                                                        question.id
                                                                      )
                                                                    }>
                                                                    <Add
                                                                      className={
                                                                        classes.add
                                                                      }
                                                                    />
                                                                  </Fab>
                                                                </Tooltip>
                                                              ) : (
                                                                <Delete
                                                                  onClick={() =>
                                                                    this.handleRemoveOption(
                                                                      multi.id,
                                                                      question.type,
                                                                      question.id
                                                                    )
                                                                  }
                                                                  color="disabled"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              )}
                                                            </Grid>
                                                          </Grid>
                                                        );
                                                      }
                                                    )}
                                                  </React.Fragment>
                                                ) : question.type === "file" ? (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      paddingTop: 10,
                                                      paddingBottom: 10,
                                                    }}>
                                                    <Typography
                                                      style={{
                                                        marginRight: 5,
                                                      }}>
                                                      Upload file
                                                    </Typography>
                                                    <CloudUpload />
                                                    <input
                                                      disabled
                                                      type="file"
                                                      name="fileName"
                                                      id="fileName"
                                                      style={{ marginLeft: 15 }}
                                                      onChange={(e) =>
                                                        this.upload(
                                                          e,
                                                          question.type,
                                                          item.id,
                                                          question.id
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                ) : question.type ===
                                                  "select-list" ? (
                                                  <React.Fragment>
                                                    <SelectValidator
                                                      id="outlined-full-width"
                                                      margin="normal"
                                                      select
                                                      SelectProps={{
                                                        MenuProps: {
                                                          className:
                                                            classes.menu,
                                                          shrink: true,
                                                        },
                                                      }}
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      label="Tham chiếu"
                                                      variant="outlined"
                                                      className={classes.input}
                                                      onChange={(e) =>
                                                        this.handleChangeReasonOption(
                                                          e.target.name,
                                                          e.target.value,
                                                          question.id,
                                                          selectReason
                                                        )
                                                      }
                                                      value={
                                                        question.options &&
                                                        question.options.id
                                                          ? question.options.id
                                                          : ""
                                                      }
                                                      name="select-list"
                                                      validators={["required"]}
                                                      errorMessages={
                                                        "Không được để trống"
                                                      }>
                                                      {selectReason
                                                        ? selectReason.map(
                                                            (reason) => {
                                                              return (
                                                                <MenuItem
                                                                  key={
                                                                    reason.id
                                                                  }
                                                                  value={
                                                                    reason.id
                                                                  }>
                                                                  {reason.text}
                                                                </MenuItem>
                                                              );
                                                            }
                                                          )
                                                        : null}
                                                    </SelectValidator>
                                                  </React.Fragment>
                                                ) : question.type ===
                                                  "scale" ? (
                                                  <React.Fragment>
                                                    {question.options.map(
                                                      (item) => {
                                                        return (
                                                          <Grid container>
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              sm={12}
                                                              md={12}
                                                              xl={12}
                                                              lg={12}>
                                                              <Select
                                                                native
                                                                value={
                                                                  Array.isArray(
                                                                    item.text
                                                                  ) &&
                                                                  item.text[0]
                                                                    ? item
                                                                        .text[0]
                                                                        .value
                                                                    : 0
                                                                }
                                                                defaultValue={0}
                                                                name="scale-start"
                                                                onChange={(e) =>
                                                                  this.handleChangeScaleOption(
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value,
                                                                    item.id,
                                                                    question.id
                                                                  )
                                                                }>
                                                                <option
                                                                  value={0}>
                                                                  0
                                                                </option>
                                                                <option
                                                                  value={1}>
                                                                  1
                                                                </option>
                                                              </Select>{" "}
                                                              đến{" "}
                                                              <Select
                                                                native
                                                                defaultValue={2}
                                                                name="scale-end"
                                                                value={
                                                                  Array.isArray(
                                                                    item.text
                                                                  ) &&
                                                                  item.text[1]
                                                                    ? item
                                                                        .text[1]
                                                                        .value
                                                                    : 1
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleChangeScaleOption(
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value,
                                                                    item.id,
                                                                    question.id
                                                                  )
                                                                }>
                                                                <option
                                                                  value={2}>
                                                                  2
                                                                </option>
                                                                <option
                                                                  value={3}>
                                                                  3
                                                                </option>
                                                                <option
                                                                  value={4}>
                                                                  4
                                                                </option>
                                                                <option
                                                                  value={5}>
                                                                  5
                                                                </option>
                                                                <option
                                                                  value={6}>
                                                                  6
                                                                </option>
                                                                <option
                                                                  value={7}>
                                                                  7
                                                                </option>
                                                                <option
                                                                  value={8}>
                                                                  8
                                                                </option>
                                                                <option
                                                                  value={9}>
                                                                  9
                                                                </option>
                                                                <option
                                                                  value={10}>
                                                                  10
                                                                </option>
                                                              </Select>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              sm={12}
                                                              md={12}
                                                              xl={12}
                                                              lg={12}>
                                                              <Grid container>
                                                                <Grid
                                                                  item
                                                                  md={1}>
                                                                  <div
                                                                    style={{
                                                                      marginTop:
                                                                        "20px",
                                                                      marginRight:
                                                                        "10px",
                                                                    }}>
                                                                    <span>
                                                                      {Array.isArray(
                                                                        item.text
                                                                      ) &&
                                                                      item
                                                                        .text[0]
                                                                        ? item
                                                                            .text[0]
                                                                            .value
                                                                        : 0}
                                                                    </span>
                                                                  </div>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  md={11}>
                                                                  <TextValidator
                                                                    id="outlined-full-width"
                                                                    margin="normal"
                                                                    placeholder="Thêm tùy chọn"
                                                                    className={
                                                                      classes.input
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleChangeScaleOption(
                                                                        e.target
                                                                          .name,
                                                                        e.target
                                                                          .value,
                                                                        item.id,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    value={
                                                                      Array.isArray(
                                                                        item.text
                                                                      ) &&
                                                                      item
                                                                        .text[0]
                                                                        ? item
                                                                            .text[0]
                                                                            .text
                                                                        : ""
                                                                    }
                                                                    name="scale-text-start"
                                                                    validators={[
                                                                      "required",
                                                                    ]}
                                                                    errorMessages={
                                                                      "Không được để trống"
                                                                    }
                                                                  />
                                                                </Grid>
                                                              </Grid>
                                                              <Grid container>
                                                                <Grid
                                                                  item
                                                                  md={1}>
                                                                  <div
                                                                    style={{
                                                                      marginTop:
                                                                        "20px",
                                                                      marginRight:
                                                                        "10px",
                                                                    }}>
                                                                    <span>
                                                                      {Array.isArray(
                                                                        item.text
                                                                      ) &&
                                                                      item
                                                                        .text[1]
                                                                        ? item
                                                                            .text[1]
                                                                            .value
                                                                        : 2}
                                                                    </span>
                                                                  </div>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  md={11}>
                                                                  <TextValidator
                                                                    id="outlined-full-width"
                                                                    margin="normal"
                                                                    placeholder="Thêm tùy chọn"
                                                                    className={
                                                                      classes.input
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleChangeScaleOption(
                                                                        e.target
                                                                          .name,
                                                                        e.target
                                                                          .value,
                                                                        item.id,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    value={
                                                                      Array.isArray(
                                                                        item.text
                                                                      ) &&
                                                                      item
                                                                        .text[1]
                                                                        ? item
                                                                            .text[1]
                                                                            .text
                                                                        : ""
                                                                    }
                                                                    name="scale-text-end"
                                                                    validators={[
                                                                      "required",
                                                                    ]}
                                                                    errorMessages={
                                                                      "Không được để trống"
                                                                    }
                                                                  />
                                                                </Grid>
                                                              </Grid>
                                                            </Grid>
                                                          </Grid>
                                                        );
                                                      }
                                                    )}
                                                  </React.Fragment>
                                                ) : null}
                                                <TextField
                                                  id="outlined-full-width"
                                                  margin="normal"
                                                  label="Ghi chú"
                                                  className={classes.input}
                                                  onChange={(e) =>
                                                    this.handleChangeTextQuestion(
                                                      e.target.name,
                                                      e.target.value,
                                                      question.id
                                                    )
                                                  }
                                                  value={
                                                    item
                                                      ? item.id
                                                        ? item.questions[key]
                                                            .note
                                                        : ""
                                                      : ""
                                                  }
                                                  name="note"
                                                  rows={3}
                                                  ít
                                                  multiline
                                                  disabled
                                                />
                                              </React.Fragment>
                                            ) : null}
                                            {item.questions.length > 1 && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                  marginTop: "5px",
                                                }}>
                                                <Delete
                                                  className={classes.add}
                                                  style={{
                                                    margin: 5,
                                                    marginBottom: 0,
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={this.handleRemoveQuestion(
                                                    key
                                                  )}
                                                />
                                              </div>
                                            )}
                                          </CardContent>
                                        </Card>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}>
                                {itemCreate.questions &&
                                  itemCreate.questions.length &&
                                  itemCreate.questions.map((question, key) => (
                                    <Draggable
                                      key={question.id}
                                      draggableId={question.id}
                                      index={key}>
                                      {(provided, snapshot) => (
                                        <div
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          // style={getItemStyle(
                                          //   snapshot.isDragging,
                                          //   provided.draggableProps.style
                                          // )}
                                        >
                                          <Card
                                            className={classes.cardQuestion}>
                                            <CardHeader
                                              style={{ paddingBottom: 0 }}
                                              title={`Câu hỏi ${key + 1}`}
                                              action={
                                                key === questions.length - 1 ? (
                                                  <Tooltip
                                                    title="Thêm mới"
                                                    disableFocusListener>
                                                    <Fab
                                                      color="primary"
                                                      aria-label="add"
                                                      size="small"
                                                      style={{
                                                        margin: 5,
                                                        marginBottom: 0,
                                                      }}
                                                      onClick={
                                                        this
                                                          .handleAddNewQuestion
                                                      }>
                                                      <Add
                                                        className={classes.add}
                                                      />
                                                    </Fab>
                                                  </Tooltip>
                                                ) : null
                                              }
                                            />
                                            <CardContent>
                                              <SelectValidator
                                                id="outlined-full-width"
                                                margin="normal"
                                                select
                                                SelectProps={{
                                                  MenuProps: {
                                                    className: classes.menu,
                                                    shrink: true,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                label="Loại câu hỏi"
                                                variant="outlined"
                                                className={classes.input}
                                                onChange={(e) => {
                                                  this.handleChangeQuestion(
                                                    e.target.name,
                                                    e.target.value,
                                                    key,
                                                    e
                                                  );
                                                }}
                                                value={questions[key].type}
                                                name="type"
                                                validators={["required"]}
                                                errorMessages={
                                                  "Không được để trống"
                                                }>
                                                {listQuestionResult?.map(
                                                  (item) => {
                                                    return (
                                                      <MenuItem
                                                        key={item.id}
                                                        value={item.id}>
                                                        {item.name}
                                                      </MenuItem>
                                                    );
                                                  }
                                                )}
                                              </SelectValidator>
                                              {question.type ? (
                                                <React.Fragment>
                                                  <TextValidator
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label={`Câu hỏi`}
                                                    className={classes.input}
                                                    onChange={(e) => {
                                                      this.handleChangeQuestion(
                                                        e.target.name,
                                                        e.target.value,
                                                        key
                                                      );
                                                    }}
                                                    value={questions[key].title}
                                                    name="title"
                                                    validators={["required"]}
                                                    errorMessages="Không được để trống"
                                                  />
                                                  {question.type ===
                                                  "datetime" ? (
                                                    <Grid
                                                      container
                                                      className={classes.grid}>
                                                      <Grid item md={6}>
                                                        <TextField
                                                          margin="normal"
                                                          className={
                                                            classes.input
                                                          }
                                                          label="dd/MM/yyyy"
                                                          InputProps={{
                                                            endAdornment: (
                                                              <InputAdornment position="end">
                                                                <Icon>
                                                                  event_note
                                                                </Icon>
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          disabled
                                                        />
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        md={6}
                                                        style={{
                                                          paddingLeft: 5,
                                                        }}>
                                                        <TextField
                                                          margin="normal"
                                                          className={
                                                            classes.input
                                                          }
                                                          label="HH:mm"
                                                          InputProps={{
                                                            endAdornment: (
                                                              <InputAdornment position="end">
                                                                <Icon>
                                                                  access_time
                                                                </Icon>
                                                              </InputAdornment>
                                                            ),
                                                          }}
                                                          disabled
                                                        />
                                                      </Grid>
                                                    </Grid>
                                                  ) : question.type ===
                                                    "time" ? (
                                                    <TextField
                                                      margin="normal"
                                                      className={classes.input}
                                                      label="HH:mm"
                                                      InputProps={{
                                                        endAdornment: (
                                                          <InputAdornment position="end">
                                                            <Icon>
                                                              access_time
                                                            </Icon>
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      disabled
                                                    />
                                                  ) : question.type ===
                                                    "date" ? (
                                                    <TextField
                                                      margin="normal"
                                                      className={classes.input}
                                                      label="dd/MM/yyyy"
                                                      disabled
                                                      InputProps={{
                                                        endAdornment: (
                                                          <InputAdornment position="end">
                                                            <Icon>
                                                              event_note
                                                            </Icon>
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                    />
                                                  ) : question.type ===
                                                    "text" ? (
                                                    <TextField
                                                      id="outlined-full-width"
                                                      margin="normal"
                                                      label="Câu trả lời ngắn"
                                                      className={classes.input}
                                                      disabled
                                                    />
                                                  ) : question.type ===
                                                    "paragraph-text" ? (
                                                    <TextField
                                                      id="outlined-full-width"
                                                      margin="normal"
                                                      label="Câu trả lời dài"
                                                      disabled
                                                      className={classes.input}
                                                    />
                                                  ) : question.type ===
                                                    "check-box" ? (
                                                    <FormGroup row>
                                                      <RadioGroup
                                                        aria-label="Gender"
                                                        name="checkBox"
                                                        className={
                                                          classes.input
                                                        }>
                                                        <FormControlLabel
                                                          value="Đồng ý"
                                                          control={
                                                            <Radio color="primary" />
                                                          }
                                                          label="Đồng ý"
                                                        />
                                                        <FormControlLabel
                                                          value="Không đồng ý"
                                                          control={
                                                            <Radio color="primary" />
                                                          }
                                                          label="Không đồng ý"
                                                        />
                                                      </RadioGroup>
                                                    </FormGroup>
                                                  ) : question.type ===
                                                    "select" ? (
                                                    <React.Fragment>
                                                      {question.options.map(
                                                        (item, i) => {
                                                          return (
                                                            <Grid
                                                              container
                                                              className={
                                                                classes.grid
                                                              }>
                                                              <Grid item md={1}>
                                                                <div
                                                                  style={{
                                                                    marginTop:
                                                                      "20px",
                                                                    marginRight:
                                                                      "10px",
                                                                  }}>
                                                                  <span>
                                                                    {i + 1}.
                                                                  </span>
                                                                </div>
                                                              </Grid>
                                                              <Grid item md={9}>
                                                                <div>
                                                                  <TextField
                                                                    id="outlined-full-width"
                                                                    margin="normal"
                                                                    placeholder="Thêm tùy chọn"
                                                                    className={
                                                                      classes.input
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      this.handleChangeTextOption(
                                                                        e.target
                                                                          .name,
                                                                        e.target
                                                                          .value,
                                                                        item.id,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    value={
                                                                      question
                                                                        .options[
                                                                        i
                                                                      ].text
                                                                    }
                                                                    name="select"
                                                                  />
                                                                </div>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                md={2}
                                                                className={
                                                                  classes.deleteCheckbox
                                                                }>
                                                                {i === 0 ? (
                                                                  <Tooltip
                                                                    title="Thêm mới"
                                                                    disableFocusListener>
                                                                    <Fab
                                                                      color="primary"
                                                                      aria-label="add"
                                                                      className={
                                                                        classes.fab
                                                                      }
                                                                      size="small"
                                                                      onClick={(
                                                                        e
                                                                      ) =>
                                                                        this.handleAddNewOption(
                                                                          e,
                                                                          question.type,
                                                                          question.id
                                                                        )
                                                                      }>
                                                                      <Add
                                                                        className={
                                                                          classes.add
                                                                        }
                                                                      />
                                                                    </Fab>
                                                                  </Tooltip>
                                                                ) : (
                                                                  <Delete
                                                                    onClick={() =>
                                                                      this.handleRemoveOption(
                                                                        item.id,
                                                                        question.type,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    color="disabled"
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                  />
                                                                )}
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        }
                                                      )}
                                                    </React.Fragment>
                                                  ) : question.type ===
                                                    "multi-check-box" ? (
                                                    <React.Fragment>
                                                      {question.options.map(
                                                        (option_item, i) => {
                                                          return (
                                                            <Grid
                                                              container
                                                              className={
                                                                classes.grid
                                                              }>
                                                              <Grid
                                                                item
                                                                md={10}>
                                                                <FormControlLabel
                                                                  value={0}
                                                                  control={
                                                                    <Checkbox
                                                                      disabled
                                                                    />
                                                                  }
                                                                  label={
                                                                    <TextField
                                                                      id="outlined-full-width"
                                                                      margin="normal"
                                                                      placeholder="Nội dung lựa chọn"
                                                                      className={
                                                                        classes.input
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        this.handleChangeTextOption(
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value,
                                                                          option_item.id,
                                                                          question.id
                                                                        )
                                                                      }
                                                                      value={
                                                                        question
                                                                          .options[
                                                                          i
                                                                        ].text
                                                                      }
                                                                      name="multi-check-box"
                                                                    />
                                                                  }
                                                                />
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                md={2}
                                                                className={
                                                                  classes.deleteCheckbox
                                                                }>
                                                                {i === 0 ? (
                                                                  <Tooltip
                                                                    title="Thêm mới"
                                                                    disableFocusListener>
                                                                    <Fab
                                                                      color="primary"
                                                                      aria-label="add"
                                                                      className={
                                                                        classes.fab
                                                                      }
                                                                      size="small"
                                                                      onClick={(
                                                                        e
                                                                      ) =>
                                                                        this.handleAddNewOption(
                                                                          e,
                                                                          question.type,
                                                                          question.id
                                                                        )
                                                                      }>
                                                                      <Add
                                                                        className={
                                                                          classes.add
                                                                        }
                                                                      />
                                                                    </Fab>
                                                                  </Tooltip>
                                                                ) : (
                                                                  <Delete
                                                                    onClick={() =>
                                                                      this.handleRemoveOption(
                                                                        option_item.id,
                                                                        question.type,
                                                                        question.id
                                                                      )
                                                                    }
                                                                    color="disabled"
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                  />
                                                                )}
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        }
                                                      )}
                                                    </React.Fragment>
                                                  ) : question.type ===
                                                    "file" ? (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        paddingTop: 10,
                                                        paddingBottom: 10,
                                                      }}>
                                                      <Typography
                                                        style={{
                                                          marginRight: 5,
                                                        }}>
                                                        Upload file
                                                      </Typography>
                                                      <CloudUpload />
                                                      <input
                                                        disabled
                                                        type="file"
                                                        name="fileName"
                                                        id="fileName"
                                                        style={{
                                                          marginLeft: 15,
                                                        }}
                                                        onChange={(e) =>
                                                          this.upload(
                                                            e,
                                                            question.type,
                                                            item.id,
                                                            question.id
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ) : question.type ===
                                                    "select-list" ? (
                                                    <React.Fragment>
                                                      <SelectValidator
                                                        id="outlined-full-width"
                                                        margin="normal"
                                                        select
                                                        SelectProps={{
                                                          MenuProps: {
                                                            className:
                                                              classes.menu,
                                                            shrink: true,
                                                          },
                                                        }}
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        label="Tham chiếu"
                                                        variant="outlined"
                                                        className={
                                                          classes.input
                                                        }
                                                        onChange={(e) =>
                                                          this.handleChangeReasonOption(
                                                            e.target.name,
                                                            e.target.value,
                                                            question.id,
                                                            selectReason
                                                          )
                                                        }
                                                        value={
                                                          question.options.id
                                                        }
                                                        name="select-list"
                                                        validators={[
                                                          "required",
                                                        ]}
                                                        errorMessages={
                                                          "Không được để trống"
                                                        }>
                                                        {selectReason
                                                          ? selectReason.map(
                                                              (reason) => {
                                                                return (
                                                                  <MenuItem
                                                                    key={
                                                                      reason.id
                                                                    }
                                                                    value={
                                                                      reason.id
                                                                    }>
                                                                    {
                                                                      reason.text
                                                                    }
                                                                  </MenuItem>
                                                                );
                                                              }
                                                            )
                                                          : null}
                                                      </SelectValidator>
                                                    </React.Fragment>
                                                  ) : question.type ===
                                                    "scale" ? (
                                                    <React.Fragment>
                                                      {question.options.map(
                                                        (item) => {
                                                          return (
                                                            <Grid container>
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                sm={12}
                                                                md={12}
                                                                xl={12}
                                                                lg={12}>
                                                                <Select
                                                                  native
                                                                  value={
                                                                    Array.isArray(
                                                                      item.text
                                                                    ) &&
                                                                    item.text[0]
                                                                      ? item
                                                                          .text[0]
                                                                          .value
                                                                      : 0
                                                                  }
                                                                  defaultValue={
                                                                    0
                                                                  }
                                                                  name="scale-start"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.handleChangeScaleOption(
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value,
                                                                      item.id,
                                                                      question.id
                                                                    )
                                                                  }>
                                                                  <option
                                                                    value={0}>
                                                                    0
                                                                  </option>
                                                                  <option
                                                                    value={1}>
                                                                    1
                                                                  </option>
                                                                </Select>{" "}
                                                                đến{" "}
                                                                <Select
                                                                  native
                                                                  defaultValue={
                                                                    2
                                                                  }
                                                                  name="scale-end"
                                                                  value={
                                                                    Array.isArray(
                                                                      item.text
                                                                    ) &&
                                                                    item.text[1]
                                                                      ? item
                                                                          .text[1]
                                                                          .value
                                                                      : 1
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.handleChangeScaleOption(
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value,
                                                                      item.id,
                                                                      question.id
                                                                    )
                                                                  }>
                                                                  <option
                                                                    value={2}>
                                                                    2
                                                                  </option>
                                                                  <option
                                                                    value={3}>
                                                                    3
                                                                  </option>
                                                                  <option
                                                                    value={4}>
                                                                    4
                                                                  </option>
                                                                  <option
                                                                    value={5}>
                                                                    5
                                                                  </option>
                                                                  <option
                                                                    value={6}>
                                                                    6
                                                                  </option>
                                                                  <option
                                                                    value={7}>
                                                                    7
                                                                  </option>
                                                                  <option
                                                                    value={8}>
                                                                    8
                                                                  </option>
                                                                  <option
                                                                    value={9}>
                                                                    9
                                                                  </option>
                                                                  <option
                                                                    value={10}>
                                                                    10
                                                                  </option>
                                                                </Select>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                sm={12}
                                                                md={12}
                                                                xl={12}
                                                                lg={12}>
                                                                <Grid container>
                                                                  <Grid
                                                                    item
                                                                    md={1}>
                                                                    <div
                                                                      style={{
                                                                        marginTop:
                                                                          "20px",
                                                                        marginRight:
                                                                          "10px",
                                                                      }}>
                                                                      <span>
                                                                        {Array.isArray(
                                                                          item.text
                                                                        ) &&
                                                                        item
                                                                          .text[0]
                                                                          ? item
                                                                              .text[0]
                                                                              .value
                                                                          : 0}
                                                                      </span>
                                                                    </div>
                                                                  </Grid>
                                                                  <Grid
                                                                    item
                                                                    md={11}>
                                                                    <TextValidator
                                                                      id="outlined-full-width"
                                                                      margin="normal"
                                                                      placeholder="Thêm tùy chọn"
                                                                      className={
                                                                        classes.input
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        this.handleChangeScaleOption(
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value,
                                                                          item.id,
                                                                          question.id
                                                                        )
                                                                      }
                                                                      value={
                                                                        Array.isArray(
                                                                          item.text
                                                                        ) &&
                                                                        item
                                                                          .text[0]
                                                                          ? item
                                                                              .text[0]
                                                                              .text
                                                                          : ""
                                                                      }
                                                                      name="scale-text-start"
                                                                      validators={[
                                                                        "required",
                                                                      ]}
                                                                      errorMessages={
                                                                        "Không được để trống"
                                                                      }
                                                                    />
                                                                  </Grid>
                                                                </Grid>
                                                                <Grid container>
                                                                  <Grid
                                                                    item
                                                                    md={1}>
                                                                    <div
                                                                      style={{
                                                                        marginTop:
                                                                          "20px",
                                                                        marginRight:
                                                                          "10px",
                                                                      }}>
                                                                      <span>
                                                                        {Array.isArray(
                                                                          item.text
                                                                        ) &&
                                                                        item
                                                                          .text[1]
                                                                          ? item
                                                                              .text[1]
                                                                              .value
                                                                          : 2}
                                                                      </span>
                                                                    </div>
                                                                  </Grid>
                                                                  <Grid
                                                                    item
                                                                    md={11}>
                                                                    <TextValidator
                                                                      id="outlined-full-width"
                                                                      margin="normal"
                                                                      placeholder="Thêm tùy chọn"
                                                                      className={
                                                                        classes.input
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        this.handleChangeScaleOption(
                                                                          e
                                                                            .target
                                                                            .name,
                                                                          e
                                                                            .target
                                                                            .value,
                                                                          item.id,
                                                                          question.id
                                                                        )
                                                                      }
                                                                      value={
                                                                        Array.isArray(
                                                                          item.text
                                                                        ) &&
                                                                        item
                                                                          .text[1]
                                                                          ? item
                                                                              .text[1]
                                                                              .text
                                                                          : ""
                                                                      }
                                                                      name="scale-text-end"
                                                                      validators={[
                                                                        "required",
                                                                      ]}
                                                                      errorMessages={
                                                                        "Không được để trống"
                                                                      }
                                                                    />
                                                                  </Grid>
                                                                </Grid>
                                                              </Grid>
                                                            </Grid>
                                                          );
                                                        }
                                                      )}
                                                    </React.Fragment>
                                                  ) : null}
                                                  <TextField
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label="Ghi chú"
                                                    className={classes.input}
                                                    onChange={(e) =>
                                                      this.handleChangeTextQuestion(
                                                        e.target.name,
                                                        e.target.value,
                                                        question.id
                                                      )
                                                    }
                                                    value={question.note}
                                                    name="note"
                                                    rows={3}
                                                    multiline
                                                    disabled
                                                  />
                                                </React.Fragment>
                                              ) : null}
                                              {questions.length > 1 && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginTop: "5px",
                                                  }}>
                                                  <Delete
                                                    className={classes.add}
                                                    style={{
                                                      margin: 5,
                                                      marginBottom: 0,
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={this.handleRemoveQuestion(
                                                      key
                                                    )}
                                                  />
                                                </div>
                                              )}
                                            </CardContent>
                                          </Card>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </React.Fragment>
                    )
                  ) : null}
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

FormTelesale.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listFormTelesale: state.form.forms,
  count: state.form.count,
  listQuestion: state.question.questions,
  reasonSelectList: state.campaign.reasonSelectList,
  allCampaign: state.campaign.allCampaign,
});

const Question = connect(null, questionAction)(FormTelesale);
const Campaign = connect(null, campaignAction)(Question);
FormTelesale = connect(mapStateToProps, mapActionsToProps)(Campaign);

export default withStyles(styles)(FormTelesale);
